const urlService : string = process.env.REACT_APP_BACKEND_URL || 'http://127.0.0.1:9000';
export {urlService}
